import { View } from '@/components/ui/tw-wrappers';
import { Colors } from '@/constants/theme';
import { useEffect } from 'react';
import { StyleSheet } from 'react-native';
import Animated, {
  FadeIn,
  useAnimatedStyle,
  useSharedValue,
  withRepeat,
  withSequence,
  withTiming,
} from 'react-native-reanimated';

export function OnboardingSkeleton() {
  const opacity = useSharedValue(0.3);

  useEffect(() => {
    opacity.value = withRepeat(
      withSequence(
        withTiming(0.7, { duration: 800 }),
        withTiming(0.3, { duration: 800 })
      ),
      -1,
      true
    );
  }, []);

  const animatedStyle = useAnimatedStyle(() => ({
    opacity: opacity.value,
  }));

  return (
    <Animated.View entering={FadeIn} style={styles.container}>
      <Animated.View style={[styles.content, animatedStyle]}>
        <View
          style={styles.mainBody}
          className="flex-col gap-10 lg:flex-row lg:gap-0"
        >
          {/* Left Column */}
          <View style={styles.columnPart} className="flex-none lg:flex-1">
            <View style={styles.fieldGroup}>
              <View style={styles.skeletonLabel} />
              <View style={[styles.skeletonInput, { height: 60 }]} />
            </View>
            <View style={styles.fieldGroup}>
              <View style={[styles.skeletonLabel, { width: 150 }]} />
              <View style={styles.skeletonInput} />
            </View>
          </View>

          {/* Right Column */}
          <View style={styles.columnPart} className="flex-none lg:flex-1">
            <View style={styles.fieldGroup}>
              <View style={[styles.skeletonLabel, { width: 120 }]} />
              <View style={styles.skeletonInput} />
            </View>
            <View style={styles.fieldGroup}>
              <View style={[styles.skeletonLabel, { width: 250 }]} />
              <View style={styles.skeletonInput} />
            </View>
          </View>
        </View>

        <View style={styles.footer}>
          <View style={styles.skeletonButton} />
        </View>
      </Animated.View>
    </Animated.View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: '100%',
    maxWidth: 1100,
    alignSelf: 'center',
    marginBottom: 40,
    paddingHorizontal: 20,
  },
  content: {
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
    borderRadius: 40,
    borderWidth: 1,
    borderColor: 'rgba(0,0,0,0.05)',
    shadowColor: Colors.light.shadow,
    shadowOffset: { width: 4, height: 4 },
    shadowOpacity: 1,
    shadowRadius: 0,
    elevation: 2,
    overflow: 'hidden',
  },
  mainBody: {
    paddingHorizontal: 30,
    paddingVertical: 30,
  },
  columnPart: {
    paddingHorizontal: 20,
    gap: 24,
  },
  fieldGroup: {
    gap: 10,
  },
  skeletonLabel: {
    height: 16,
    width: 130,
    backgroundColor: '#f0f0f0',
    borderRadius: 4,
  },
  skeletonInput: {
    height: 48,
    width: '100%',
    backgroundColor: '#f5f5f5',
    borderRadius: 12,
  },
  footer: {
    paddingHorizontal: 30,
    paddingBottom: 30,
    justifyContent: 'center',
    alignItems: 'flex-end',
  },
  skeletonButton: {
    height: 44,
    width: 250,
    backgroundColor: '#f0f0f0',
    borderRadius: 12,
  },
});
